import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { createTheme, ThemeProvider } from "@mui/material";
import {
  AppInsightsErrorBoundary,
  ReactPlugin,
} from "@microsoft/applicationinsights-react-js";

/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */
const theme = createTheme({
  palette: {
    primary: {
      main: "#7CBA25",
      contrastText: "#fff",
    },
    secondary: {
      main: "#2BB9D9",
      contrastText: "#fff",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: "#FFF",
          fontSize: 24,
          fontFamily: "calibri",
          fontWeight: 300,
          letterSpacing: 0.48,
          lineHeight: "normal",
          "&:hover": {
            backgroundColor: (props) => props.color || "transparent", // Use the hover color prop dynamically
          },
          height: 30,
          lineHeight: "normal",
          borderRadius: 8,
          textTransform: "inherit",
        },
        variants: [
          {
            props: { size: "sm" }, //for action buttons
            style: {
              width: 60,
            },
          },
          {
            props: { size: "md" }, // for login
            style: {
              width: 120,
            },
          },
          {
            props: { size: "lg" }, // , create , update ,yes , no
            style: {
              width: 170,
            },
          },
          {
            props: { size: "xl" }, //for
            style: {
              width: 773,
            },
          },
        ],
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "#999590",
          fontFamily: "calibri",
          fontSize: 15,
          lineHeight: "normal",
          fontWeight: 300,
          letterSpacing: 0.72,
        },
      },
    },
  },
});
const msalInstance = new PublicClientApplication(msalConfig);
const reactPlugin = new ReactPlugin();
// const ComponentThatMayThrowAnError = () => {
//   // This error will be caught by the AppInsightsErrorBoundary
//   throw new Error('An error occurred');
//   return <div>Hello, world!</div>;
// };
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <ThemeProvider theme={theme}>
        <AppInsightsErrorBoundary
          onError={() => <h1>I believe something went wrong</h1>}
          appInsights={reactPlugin}
        >
          <App />
        </AppInsightsErrorBoundary>
      </ThemeProvider>
    </MsalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
